import { render, staticRenderFns } from "./web2023051003.vue?vue&type=template&id=36c82207&scoped=true&"
import script from "./web2023051003.vue?vue&type=script&lang=js&"
export * from "./web2023051003.vue?vue&type=script&lang=js&"
import style0 from "./web2023051003.vue?vue&type=style&index=0&id=36c82207&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c82207",
  null
  
)

export default component.exports